import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { blobTypeStoreReadSettingsAdapts } from './blob-type-store-read-settings.adapter';
import { AmazonS3CompatibleStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/amazon-s3-compatible-store-read-settings';
import { AmazonS3StoreReadSettingsAdapter } from './s3-store-read-settings.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonS3CompatibleStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        deleteFilesAfterCompletion: '*',
        prefix: '*'
    }
})
export class AmazonS3CompatibleStoreReadSettingsAdapter extends AmazonS3StoreReadSettingsAdapter {}
